<section id="main-cep">
  <div id="records" class="row">
    <div id="main-cep-block">
      <h2 class="record-title">Consulta CEP - Veículos Brasil</h2>
      <p class="text-description">
        Utilize a consulta abaixo para verificar a disponibilidade de atuação de
        acordo com o endereço do cliente
      </p>
      <div class="input-cep">
        <label for="cepAgenteInput" class="lbl-cep"
          >Digite o CEP do cliente</label
        >
        <input
          id="cepAgenteInput"
          class="form-control"
          type="text"
          placeholder="00000-000"
          mask-number
          [mask]="'00000-000'"
          [minLength]="8"
          [maxLength]="9"
          appOnlyNumberRestrictive
          appOnlyDigitsLengthValidator
          [(ngModel)]="cepAgente"
        />
        <app-loader-default
          class="loading-cep"
          text="Pesquisando CEP, Aguarde..."
          [show]="isBuscandoCep"
          size="fa-1x"
        >
        </app-loader-default>
        <button
          *ngIf="!isBuscandoCep"
          [ngClass]="
            cepErrorStatus === 'OK'
              ? 'btn btn-border-orange'
              : 'btn btn-full-orange'
          "
          (click)="onCepExit()"
        >
          Consultar CEP
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
        <button
          *ngIf="!isBuscandoCep && cepErrorStatus === 'OK'"
          class="btn btn-full-orange"
          (click)="cadastrarProposta()"
        >
          Cadastrar Ficha Veículos Brasil
          <i class="fa fa-plus"></i>
        </button>
      </div>
      <div *ngIf="endereco || agenteEndereco" class="msg-retorno">
        <p *ngIf="cepErrorStatus === 'OK'" class="text-retorno">
          <span class="small-icon icon_info"></span>
          <span class="msg-color"
            >Essa proposta será enviada para o Agente:</span
          >
          {{ agenteEndereco?.code }} - {{ agenteEndereco?.name }} -
          {{ agenteEndereco?.address.city }}-{{
            agenteEndereco?.address.state
          }}, {{ agenteEndereco?.address.district }}.
        </p>
        <p *ngIf="cepErrorStatus === 'ERRO'" class="text-retorno">
          <span class="small-icon icon_info_error"></span>
          <span class="msg-color-error">{{
            agentDestinationErrorMessage
          }}</span>
          Cidade: {{ endereco?.cidade }} | Estado: {{ endereco?.uf }}
        </p>
      </div>
      <div *ngIf="cepErroMessage" class="msg-retorno">
        <p *ngIf="cepErroMessage" class="text-retorno">
          <span class="small-icon icon_info_error"></span>
          <span class="msg-color-error">
            Digite um CEP válido para realizar a consulta
          </span>
        </p>
      </div>
    </div>
  </div>
</section>
